<div class="opportunity-card">
    <div class="image-container">
        <img class="circle-img" [appImageSrc]="opportunity?.coverImage" alt="">
        <span class="typeBadge">{{ opportunity?.applicationType | applicationtype }}</span>
    </div>

    <div class="details">
        <span class="companyName" *ngIf="opportunity?.providerName">{{ opportunity.providerName }}</span>
        <span class="title">{{ opportunity?.title }}</span>
        <span class="category" *ngIf="opportunity?.categories?.length">
            {{ (opportunity.categories[0]?.category | category | async) }}
            <span class="text-muted" *ngIf="opportunity.categories.length > 1">
                +{{ opportunity.categories.length - 1 }}
            </span>
        </span>
        <span class="major" *ngIf="opportunity?.majors?.length">
            {{ (opportunity.majors[0]?.major | major | async) }}
            <span class="text-muted" *ngIf="opportunity.majors.length > 1">
                +{{ opportunity.majors.length - 1 }}
            </span>
        </span>
        <div class="footer">
            <span>{{ ((opportunity?.cities?.length ? opportunity.cities : opportunity?.city) | city | async) }}</span>
            <span>{{ opportunity?.deadline ? (opportunity.deadline | date:'mediumDate') : 'No deadline' }}</span>
        </div>
    </div>
</div>
